import { useCallback } from "react";
import { NavigateOptions, useLocation, useNavigate } from "react-router-dom";
import { Paths } from "src/constants/paths";
import { useProduct } from "src/context/ProductProvider";
import { useSubscription } from "src/context/SubscriptionProvider";
import { useVisit } from "src/context/VisitProvider";

type ContinueOptions = NavigateOptions & {
  mergeSearch?: Record<string, string | number | boolean | null | undefined>;
};

export const useCancellationContinue = () => {
  const productSlug = useProduct((p) => p.slug);
  const visitSlug = useVisit((v) => v.slug);
  const navigate = useNavigate();
  const location = useLocation();
  const subscriptionId = useSubscription((s) => s.id);

  return useCallback(
    (path: string, options?: ContinueOptions) => {
      const params = new URLSearchParams(location.search);

      if (options?.mergeSearch) {
        for (const [k, v] of Object.entries(options.mergeSearch)) {
          if (v == null || v === false) params.delete(k);
          else params.set(k, String(v));
        }
      }
      const qs = params.toString();
      const suffix = qs ? `?${qs}` : "";

      navigate(
        `/${productSlug}/${visitSlug}/${subscriptionId}/${Paths.CANCELLATION}/${path}${suffix}`,
        options
      );
    },
    [location.search, navigate, productSlug, subscriptionId, visitSlug]
  );
};
